import { REIMBURSEMENTS_LIST_LOCKED_COLUMN_IDS } from '../constants/listColumns'
import type {
  ReimbursementListColumnId,
  ReimbursementListLockedColumnId,
} from '../types/listColumns'

export {
  REIMBURSEMENTS_LIST_COLUMN_OPTIONS,
  REIMBURSEMENTS_LIST_CUSTOMIZABLE_COLUMN_OPTIONS,
  REIMBURSEMENTS_LIST_LOCKED_COLUMN_IDS,
  REIMBURSEMENTS_LIST_DATA_COLUMN_IDS,
} from '../constants/listColumns'

export type {
  ReimbursementListColumnId,
  ReimbursementListLockedColumnId,
} from '../types/listColumns'

export function isReimbursementListLockedColumn(
  columnId: ReimbursementListColumnId,
): columnId is ReimbursementListLockedColumnId {
  return REIMBURSEMENTS_LIST_LOCKED_COLUMN_IDS.includes(
    columnId as ReimbursementListLockedColumnId,
  )
}

/** Ensure locked columns are always present in a visibility set (order irrelevant). */
export function withLockedReimbursementListColumns(
  columnIds: ReimbursementListColumnId[],
): ReimbursementListColumnId[] {
  const withoutLocked = columnIds.filter(
    (columnId) => !isReimbursementListLockedColumn(columnId),
  )
  return [...REIMBURSEMENTS_LIST_LOCKED_COLUMN_IDS, ...withoutLocked]
}
